import React, {useState} from "react";
import "./style.scss";
import Menu from "../Menu";

const Header = ({title, redirectUrl}) => {
  const navigateButton = redirectUrl ? "<" : "";

  const [openMenu, setOpenMenu] = useState(false);

  const onClickHandler = () => {
    setOpenMenu(true);
  };

  return (
    <>
      <div className="header-container">
        <label className="header-text">{title}</label>
        {redirectUrl ? (
          <div className="menu-logo" onClick={onClickHandler}>
            {navigateButton}
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div>{openMenu && <Menu close={() => setOpenMenu(false)} />}</div>
    </>
  );
};

export default Header;
